import { Box } from "@mui/material";
import logo from "@/assets/pittogrammaNolocom.png";
import React from "react";
import { useNavigate } from "react-router-dom";
import { sidebarTheme } from "@/styles/sidebarTheme";

export const SidebarLogoBox: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate("/")}
      sx={{
        background: sidebarTheme.background.logoBox,
        border: `2px solid ${sidebarTheme.menu.selected.text}`,
        boxShadow: `0px 8px 20px ${sidebarTheme.menu.selected.text}99`,
        display: "flex",
        alignItems: "center",
        m: 2,
        justifyContent: "center",
        height: 100,
        borderRadius: 2,
        userSelect: "none",
        cursor: "pointer",
        transition: "transform 0.2s, opacity 0.2s",
        "&:hover": {
          transform: "scale(1.05)",
          opacity: 0.9,
        },
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Backoffice Logo"
        sx={{
          width: 100,
          height: 100,
          objectFit: "contain",
        }}
      />
    </Box>
  );
};
